module.exports = __webpack_public_path__ + "static/media/productCloud.7e80e2fe.svg";